/*
 * Copyright (c) 2021, stokke.com
 * All rights reserved.
 */

import {useIntl} from 'react-intl'

/**
 * @returns {String} the country (2-letter code) based on selected locale
 */
export const useCountry = () => {
    const {locale} = useIntl()
    return locale.split('-')[1]
}
